import React from 'react';

const SearchIcon = ({size}) => (
  <svg width={size} height={size} fill="none" viewBox={'0 0 21 20'}>
    <path fill="currentColor"
          fillRule="evenodd"
          d="M8.12 2.08a5.53 5.53 0 1 0 0 11.07 5.53 5.53 0 0 0 0-11.07ZM.92 7.62a7.2 7.2 0 1 1 12.84 4.47l6.08 6.07-1.18 1.18-6.08-6.08A7.2 7.2 0 0 1 .91 7.61Z"
          clipRule="evenodd"/>
  </svg>
);

export default SearchIcon;
